import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("sinovar-lang") || "en";
    }
    return "en";
  });

  const changeLang = useCallback((next) => {
    setLang(next);
    if (typeof window !== "undefined") {
      localStorage.setItem("sinovar-lang", next);
      document.documentElement.lang = next;
    }
  }, []);

  const toggleLang = useCallback(() => {
    changeLang(lang === "id" ? "en" : "id");
  }, [lang, changeLang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
